export default "__VITE_ASSET__C60vw93B__"